<template>
  <div class="zusatzbausteine-privat mb-6">

    <gewerbe-person :state-path="$store.getters.personPath(key)" :used="['firstname', 'lastname']" :disabled="disabled"></gewerbe-person>

    <zusatzbaustein-tabelle :person-ref="key" :items="Object.values(privatZusatzbausteine)" ></zusatzbaustein-tabelle>

  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import twowayBindingMixin, { mapTwoWay } from '../../store/twowayBindingMixin';
import Zusatzbausteine from '@/store/config/gewerbeZusatzbausteine';
import GewerbePerson from './GewerbePerson';
import { mapState } from 'vuex';

export default {
  components: { GewerbePerson, ZusatzbausteinTabelle: () => import('./ZusatzbausteinTabelle') },
  mixins: [ twowayBindingMixin, ValidationMixin ],
  data() {
    return {
      privatZusatzbausteine: Zusatzbausteine.privat
    };
  },
  computed: {
    ...mapTwoWay([
      'key',
    ]),
    ...mapState({
      matrixSelection: state => state.gewerbe.ui.matrixSelection,
      excludeGF: state => state.gewerbe.ui.excludeGF
    }),
    disabled() {
      return this.matrixSelection.produkte.filter(p => /^SPEZ-PBV*/.test(p)).length === 0 || this.excludeGF;
    }
  }
};
</script>

<style>

</style>

